import { render } from "./SessionRecording.vue?vue&type=template&id=489e2615&scoped=true"
import script from "./SessionRecording.vue?vue&type=script&lang=js"
export * from "./SessionRecording.vue?vue&type=script&lang=js"

import "./SessionRecording.vue?vue&type=style&index=0&id=489e2615&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489e2615"]])

export default __exports__